import React from "react";
import SeoHead from "@/components/SeoHead";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import BrandIntro from "@/components/landing/BrandIntro";
import StoryBox from "@/components/landing/StoryBox";
import ContactSection from "@/components/landing/ContactSection";
import Footer from "@/components/landing/Footer";

const LandingPage = () => (
  <div className="font-sans-clean" data-testid="landing-root">
    <SeoHead pageKey="home" />
    <Header />
    <main>
      <Hero />
      <BrandIntro />
      <StoryBox />
      <ContactSection />
    </main>
    <Footer />
  </div>
);

export default LandingPage;
